(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('loadImage', loadImageProvider);

    var extend = angular.extend;

    loadImageProvider.$inject = [];
    function loadImageProvider() {
        var provider = this;
        provider.defaults = defaults();
        provider.$get = $get;

        ////////////////////////////////////////

        $get.$inject = ['$q', '$window'];
        function $get($q, $window) {
            return loadImage;

            function loadImage(file, options) {
                var opts = extend({}, provider.defaults, options),
                    deferred = $q.defer(),
                    load = $window.loadImage;
                
                opts.canvas = opts.canvas || opts.blob || opts.dataUrl || opts.objectUrl;

                load(file, callback, opts);
                return deferred.promise;

                function callback(img) {
                    if (img instanceof HTMLImageElement)
                        $q.resolve(img);
                    else if (img instanceof HTMLCanvasElement) {
                        if (opts.objectUrl || opts.blob)
                            img.toBlob(blobCallback, file.type);
                        else if (opts.dataUrl)
                            deferred.resolve(img.toDataURL(file.type));
                        else
                            deferred.resolve(img);
                    }
                    else
                        deferred.reject(img);

                    function blobCallback(blob) {
                        deferred.resolve(opts.objectUrl ? URL.createObjectURL(blob) : blob);
                    }
                }
            }
        }

        function defaults() {
            return {
                // Main
                orientation: true,
                meta: true,
                canvas: true,
                maxWidth: undefined,
                maxHeight: undefined,

                // Grant's Custom Options
                // Setting any of these enables the canvas option. 
                // Only one of these should be set.  If you set multiples, the precedance order is objectUrl, blob, then dataURL.
                blob: false,
                dataURL: false,
                objectUrl: false,

                // Others
                minWidth: undefined,
                minHeight: undefined,
                sourceWidth: undefined,
                sourceHeight: undefined,
                top: undefined,
                right: undefined,
                bottom: undefined,
                left: undefined,
                contain: undefined,
                cover: undefined,
                aspectRatio: undefined,
                pixelRatio: undefined,
                downsamplingRatio: undefined,
                crop: undefined,
                crossOrigin: undefined,
                noRevoke: undefined
            }
        }
    }
})();